<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="flag.FlagName" label="Hashtag" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="flag.ShortTag" label="Short tag" hint="Ví dụ: #don_moi" persistent-hint class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-color-picker v-model="flag.FlagColor" label="Màu sắc" class="input-group--focused"  hide-canvas></v-color-picker>
                </v-flex>
                <v-flex lg12 md12 sm12>
                     <v-textarea v-model="flag.Note" label="Ghi chú" class="input-group--focused"></v-textarea>
                </v-flex>
                <v-flex lg4 md4 sm12>
                     <v-switch v-model="flag.IsStandby" label="Cảnh báo đơn trễ" class="input-group--focused"></v-switch>
                </v-flex>
                <v-flex lg4 md4 sm12 v-if="flag.IsStandby">
                     <v-select v-model="flag.FlagType" :items="flag_types" item-text="name" item-value="value" label="Loại tag" class="input-group--focused"></v-select>
                </v-flex>
                <v-flex lg4 md4 sm12 v-if="flag.IsStandby">
                    <v-text-field v-model="flag.NumberOfDay" label="Số ngày trễ" type="number" step="1" class="input-group--focused"></v-text-field>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import { sendErrorNotice } from "@/commons/utils";
export default {
    data() {
        return {
            flag_types: configs.FLAG_TYPE_LIST
        }
    },
    computed: {
        ...mapState({
            loading: state => state.flag.loading,
            flag: state => state.flag.selected
        }),
        modifyId() {
            return this.$route.params.Pid;
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("flag/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("flag/setDetail", { data: {
                        ID: 0,
                        FlagName: "",
                        ShortTag: "",
                        FlagColor: "",
                        Note: "",
                        IsStandby: false,
                        FlagType: null,
                        NumberOfDay: null
                    }
                })
            }
        },
        async saveData() {
            const shortTag = this.flag.ShortTag ? this.flag.ShortTag.trim() : "";
            if (!this.flag.FlagName || !this.flag.FlagName.trim()) {
                sendErrorNotice("Hashtag không được để trống.");
                return;
            }
            if (!this.flag.FlagColor) {
                sendErrorNotice("Màu sắc không được để trống.");
                return;
            }
            if (!shortTag) {
                sendErrorNotice("Short tag không được để trống.");
                return;
            }
            if (!shortTag.startsWith("#")) {
                sendErrorNotice("Short tag phải bắt đầu bằng ký tự #.");
                return;
            }
            if (this.flag.IsStandby && !this.flag.FlagType) {
                sendErrorNotice("Loại tag không được để trống khi bật cảnh báo đơn trễ.");
                return;
            }
            const numberOfDay = Number(this.flag.NumberOfDay);
            if (this.flag.IsStandby && (!Number.isInteger(numberOfDay) || numberOfDay <= 0)) {
                sendErrorNotice("Số ngày trễ phải là số nguyên lớn hơn 0.");
                return;
            }
            const success = await this.$store.dispatch("flag/setDetail", {
                data: {
                    ID: this.flag.ID,
                    FlagName: this.flag.FlagName ? this.flag.FlagName.trim() : "",
                    ShortTag: shortTag,
                    FlagColor: this.flag.FlagColor ? (this.flag.FlagColor.hex || this.flag.FlagColor) : '' ,
                    Note: this.flag.Note,
                    IsStandby: this.flag.IsStandby,
                    FlagType: this.flag.FlagType,
                    NumberOfDay: this.flag.IsStandby ? numberOfDay : this.flag.NumberOfDay
                },
                id: this.flag.ID
            });
            if (success) {
                window.getApp.$emit("APP_NAVIGATE", "FlagList");
            }
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.flag.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
